import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type { ActivitiesFiltersParams } from '@recruitee/activities-types';
import { HttpApiService } from '@recruitee/http';

import { NotificationCounterFilteredStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterFilteredHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(filters: ActivitiesFiltersParams): Observable<NotificationCounterFilteredStore> {
    return this.httpApi.get('tracking/notifications/counters', { ...filters });
  }
}
